import React, { useState } from "react";
import { API_BASE_URL, API_KEY, CONTACT_ENDPOINT, FOOTER_INFO } from "../config";

const initialState = {
  name: "",
  email: "",
  message: "",
};

export const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState);
  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };

  const clearState = () => setState({ ...initialState });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Sending...");
    
    try {
      const response = await fetch(`${API_BASE_URL}${CONTACT_ENDPOINT}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": API_KEY,
        },
        body: JSON.stringify({ name, email, message }),
      });

      const result = await response.json();
      console.log(result);

      if (result.success) {
        setStatus("Message sent successfully!");
        clearState();
      } else {
        setStatus("Failed to send message.");
        console.error(result.error);
      }
    } catch (error) {
      setStatus("Error sending message.");
      console.error(error);
    }

  };

  return (     

    <div id="contact">
      <div className="container">
        <div className="col-md-8">
          <div className="row">
            <div className="section-title">
              <h1>Get In Touch</h1>
              <p>
                Have a question or need a custom solution? Fill out the form below, and our team will respond promptly.
              </p>
            </div>

            <form name="sentMessage" validate onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      placeholder="Name"
                      required
                      value={name}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group">
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      placeholder="Email"
                      required
                      value={email}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>

              <div className="form-group">
                <textarea
                  name="message"
                  className="form-control"
                  rows="4"
                  placeholder="Message"
                  required
                  value={message}
                  onChange={handleChange}
                />
              </div>

              <div id="success" style={{ marginBottom: "10px", color: "green" }}>
                {status}
              </div>

              <button type="submit" className="btn btn-custom btn-lg">
                Send Message
              </button>
            </form>
          </div>
        </div>

        <div className="col-md-3 col-md-offset-1 contact-info">
          <div className="contact-item">
            <h3>Contact Info</h3>
            <p>
              <i className="fa fa-map-marker"></i> {props.data?.address}
            </p>
          </div>

          {/* Call */}
          <div className="contact-item">
            <p>
              <i className="fa fa-phone"></i>
              <a href={`tel:${props.data?.phone}`}> {props.data?.phone}</a>
            </p>
          </div>

          {/* Email */}
          <div className="contact-item">
            <p>
              <i className="fa fa-envelope-o"></i>
              <a href={`mailto:${props.data?.email}`}> {props.data?.email}</a>
            </p>
          </div>

          {/* WhatsApp */}
          <div className="contact-item">
            <p>
              <i className="fa fa-whatsapp"></i>
              <a 
                href={`https://wa.me/${props.data?.phone?.replace(/\D/g, "")}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                WhatsApp
              </a>
            </p>
          </div>
        </div>

        {/* <div className="col-md-12">
          <div className="row">
            <div className="social">
              <ul>
                <li><a href={props.data?.facebook}><i className="fa fa-facebook"></i></a></li>
                <li><a href={props.data?.twitter}><i className="fa fa-twitter"></i></a></li>
                <li><a href={props.data?.youtube}><i className="fa fa-youtube"></i></a></li>
              </ul>
            </div>
          </div>
        </div> */}
      </div>

      <div id="footer">
        <div className="container text-center">
          <p>
            {FOOTER_INFO.copyright} Designed by {" "}
            <a
              href={FOOTER_INFO.designedByUrl}
              target="_blank"
              rel="noopener noreferrer nofollow"
            >
              {FOOTER_INFO.designedBy}
            </a>
          </p>
              
        </div>
      </div>
    </div>
  );
};
